export const parseQueryParams = (url: string): Record<string, string> => {
  const queryStart = url.indexOf('?');
  if (queryStart === -1) return {};

  const queryString = url.substring(queryStart + 1);
  const params = new URLSearchParams(queryString);

  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
